export enum CircleAction {
  grow = 'grow',
  shrink = 'shrink',
  holdLarge = 'holdLarge',
  holdSmall = 'holdSmall',
  idle = 'idle',
}

export interface BreathworkStepUiModel {
  title?: string | null;
  subtitle?: string | null;
  description?: string | null;
  /** Circle size 0–1, where 1 = fully expanded */
  circleSize: number | null;
  /** Duration for this UI step in milliseconds */
  durationMs?: number | null;
  /** Hex colour string e.g. '#A8D9F1' */
  color?: string | null;
  /** Animation action for this step — inferred by the engine if absent in Firestore data */
  circleAction?: CircleAction | null;
}
